<template>
    <div>
        <component :is="currentComponent" @goToComponent="handleComponentChange" :money="componentParams.money">
        </component>
    </div>
</template>
<script>
import OrdersList from './Order/OrdersList.vue'
import OrdersDetail from './Order/OrdersDetail.vue'
import ShouhouDetail from './Order/ShouhouDetail.vue'
export default {
    name: 'MyOrders',
    components: {
        OrdersList,
        OrdersDetail,
        ShouhouDetail
    },
    data() {
        return {
            currentComponent: 'OrdersList',
            componentParams: {
                order_sn: '',
                order_aid: '',
            }
        }
    },
    mounted() {
        // 组件挂载时默认显示订单列表
        this.currentComponent = 'OrdersList';
    },
    methods: {
        // 处理组件切换
        handleComponentChange(componentName, params) {
            if (params) {
                this.componentParams = { ...this.componentParams, ...params };
            }
            this.currentComponent = componentName;
        }
    }
}
</script>
<style scoped>
/* 可以根据需要添加样式 */
</style>